import { Polyline } from '@vis.gl/react-google-maps';

import { resolveZIndex } from './markerUtilities';

type LineStringMarkerProps = {
  path: google.maps.LatLngLiteral[];
  color: string;
  isActive: boolean;
  onClick: () => void;
};

const LineStringMarker = ({
  path,
  color,
  isActive,
  onClick,
}: LineStringMarkerProps) => (
  <>
    {isActive && (
      <>
        <Polyline
          path={path}
          strokeColor="#1E88E5"
          strokeWeight={18}
          strokeOpacity={0.5}
          zIndex={498}
        />
        <Polyline
          path={path}
          strokeColor="#FFFFFF"
          strokeWeight={14}
          zIndex={499}
        />
      </>
    )}
    <Polyline
      path={path}
      strokeColor={color}
      strokeWeight={isActive ? 10 : 3}
      zIndex={resolveZIndex('polyline', isActive)}
      onClick={onClick}
    />
  </>
);

export default LineStringMarker;
